// @flow

import styled from 'styled-components';

export const SimpleTipsList = styled.ul`
  padding: 0 30px;
`;

export const SimpleTipItem = styled.li`
  margin: 6px 0;
`;

export const SimpleTipsSortedSubList = styled.ol`
  margin-left: 32px;
`;

export const SimpleTipsSubListItem = styled.li`
  margin: 4px 0;
`;
